<div class="faq-section" *ngIf="faqs.length > 0">
  <div class="width-paginate title-card" [style.background-color]="accentColor">
    <h2 class="quicksand-bold">PREGUNTAS FRECUENTES</h2>
  </div>

  <div class="width-paginate faq-list">
    <article class="faq-item" *ngFor="let faq of faqs; trackBy: trackByFaq">
      <button
        type="button"
        class="faq-question"
        #faqQuestion
        [style.min-height.px]="questionHeight"
        [class.is-expanded]="isExpanded(faq.id)"
        [attr.aria-expanded]="isExpanded(faq.id)"
        [attr.aria-controls]="'faq-answer-' + faq.id"
        (click)="toggleFaq(faq.id)">
        <span class="quicksand-medium">{{ faq.ask }}</span>
        <img
          class="faq-icon"
          [class.is-expanded]="isExpanded(faq.id)"
          src="./assets/img/flecha-abajo-continua.png"
          [alt]="isExpanded(faq.id) ? 'Cerrar respuesta' : 'Abrir respuesta'">
      </button>

      <div
        *ngIf="isExpanded(faq.id)"
        class="faq-answer quicksand-medium"
        [id]="'faq-answer-' + faq.id">
        <p>{{ faq.answer }}</p>
      </div>
    </article>
  </div>
</div>
